import styled from 'styled-components';
import { border, layout, padding, margin, color, space, typography } from 'styled-system';
import { GeneralInputStyleProps, defaultInputStyleProps } from './GeneralInputStyles';
import { FC } from 'react';
import { VStack } from '@bpba/ui-components';
import { getValidationOptions } from './GenericInput';
import { GenericInputError } from './GenericInputError';
import { InputProps } from './InputProps';
import { useInputAriaErrors } from './useInputAriaErrors';

/**
 *  Tipo de datos ingresado por el usuario. Este  texto se
 *  utiliza para los mensaje de error.
 */
const CHARACTERS_TYPE = 'Caracteres';

type Props = {
  maxLength?: number;
  minLength?: number;
} & InputProps &
  React.ComponentProps<typeof StyledTextArea>;

export const TextArea: FC<Props> = (props) => {
  const { name, formRegister, errorCollection, required, maxLength, minLength, mr, ...otherProps } = props;
  const validationOptions = getValidationOptions(CHARACTERS_TYPE, required, undefined, maxLength, minLength);
  const validations = formRegister(name, validationOptions);
  const accessibilityErrorsConfig = useInputAriaErrors(name, errorCollection, required);

  return (
    <VStack width="100%" mr={mr}>
      <StyledTextArea {...accessibilityErrorsConfig} {...otherProps} {...validations} />
      <GenericInputError fieldName={name} id={accessibilityErrorsConfig['aria-describedby']} errorCollection={errorCollection} />
    </VStack>
  );
};

const StyledTextArea = styled.textarea<GeneralInputStyleProps>(border, layout, padding, margin, color, space, typography, (props) => ({
  resize: 'none',
  '::placeholder': {
    color: props.theme.colors.placeholder,
    opacity: 1,
  },
}));

StyledTextArea.defaultProps = {
  ...defaultInputStyleProps,
};
